"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapPlainTransaction = exports.wrapSdkTransaction = exports.executeTxEnsureSuccess = exports.executeTxGetEvents = exports.executeTx = exports.useFunctionModule = void 0;
const error_1 = require("./error");
const enum_1 = require("./enum");
const useFunctionModule = (that, module) => {
    return Object.fromEntries(Object.entries(module).map(([funcName, funcImpl]) => {
        return [funcName, funcImpl.bind(that)];
    }));
};
exports.useFunctionModule = useFunctionModule;
function isPromise(value) {
    return Boolean(value && typeof value.then === 'function');
}
function executeTx(contractTxPromise) {
    return contractTxPromise.then((tx) => tx.wait());
}
exports.executeTx = executeTx;
function executeTxGetEvents(contractTxPromise) {
    return contractTxPromise.then((tx) => tx.wait()).then(receipt => receipt.events);
}
exports.executeTxGetEvents = executeTxGetEvents;
async function executeTxEnsureSuccess(contractTxPromise) {
    let receipt;
    if (isPromise(contractTxPromise)) {
        receipt = await executeTx(contractTxPromise);
    }
    else {
        receipt = await contractTxPromise.wait();
    }
    const txEvents = receipt.events;
    if (!txEvents) {
        throw new error_1.TectonicSDKError("This transaction is expected to emit events but it did not. Check params for sending the transaction.");
    }
    const failureEvent = txEvents.find(e => e.event === "Failure");
    if (failureEvent) {
        const code = enum_1.TokenError[failureEvent.args[0]];
        const failureInfo = enum_1.TokenFailureInfo[failureEvent.args[1]];
        let rootCause;
        if (failureEvent.args[0] == enum_1.TokenError.MATH_ERROR) {
            rootCause = enum_1.MathError[failureEvent.args[2]];
        }
        else if (failureEvent.args[0] == enum_1.TokenError.TECTONIC_CORE_CALCULATION_ERROR
            || failureEvent.args[0] == enum_1.TokenError.TECTONIC_CORE_REJECTION) {
            rootCause = enum_1.TectonicCoreError[failureEvent.args[2]];
        }
        throw new error_1.TectonicSDKError(`Receive Failure event but expect transaction to be successful. Error:${failureEvent.args}`, error_1.TectonicSDKErrorType.TokenError, code, failureInfo, rootCause);
    }
    return receipt;
}
exports.executeTxEnsureSuccess = executeTxEnsureSuccess;
async function wrapSdkTransaction(contractTxPromise) {
    const tx = await contractTxPromise;
    const txHash = tx.hash;
    return {
        txHash,
        txReceiptPromise: executeTxEnsureSuccess(tx),
    };
}
exports.wrapSdkTransaction = wrapSdkTransaction;
async function wrapPlainTransaction(contractTxPromise) {
    const tx = await contractTxPromise;
    const txHash = tx.hash;
    return {
        txHash,
        txReceiptPromise: tx.wait(),
    };
}
exports.wrapPlainTransaction = wrapPlainTransaction;
//# sourceMappingURL=util.js.map